<div class="flex items-center justify-between max-w-full" *ngIf="(breadcrumbService.itemsHandler | async)?.length">
  <p-breadcrumb [model]="(breadcrumbService.itemsHandler | async) || undefined" [home]="home"></p-breadcrumb>
  <button *ngIf="helpService.hasHelp | async" pButton (click)="onShowHelp()" class="p-button-rounded p-button-text"
    icon="pi pi-question-circle"></button>
</div>